import * as React from 'react';

import Component from './Text';
import { TextProps } from './model';

export type { TextProps };

export const WBText: React.FC<TextProps> = (props) => {
	return <Component {...props} />;
};
